import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <div className="header-nav">
      <Link to="/">
        <img src="/logo.svg" alt="Logo" /> 
      </Link>
      
      {/* Tombol bawaan, accountStatus="full" biar avatar & address muncul barengan */}
      <ConnectButton 
        accountStatus="full" 
        chainStatus="none" 
        showBalance={false} 
      />
    </div>
  );
}